import {DceComponent, DceHTMLElement} from "dce-engine";
import {DceAjax,  DceAjaxResponse} from "dce-ajax";
import Dce from "dce-engine/lib/decorators/Dce";

interface QuantityInputProps {
    submitOnChange: boolean;
}

@Dce("QuantityInput")
export default class QuantityInput extends DceComponent<QuantityInputProps>{

    private quantityInput: HTMLInputElement;
    private form: HTMLFormElement;

    constructor(elem: DceHTMLElement, props: QuantityInputProps) {
        super(elem, props);
        this.quantityInput = elem.querySelector('input[name=quantity]')

        this.form = this.quantityInput.closest('form');

        if(props.submitOnChange){
            this.quantityInput.addEventListener('change', e =>{
                this.form.dispatchEvent(new Event('submit'));
            });
        }

    }

    public decrementQuantity(e: Event){
        this.changeQuantity(v => v-1);
    }

    public incrementQuantity(e: Event){
        this.changeQuantity(v => v+1);
    }

    private changeQuantity(callback: (i:number) => number){

        let quant = parseInt(this.quantityInput.value);
        quant = callback(quant);
        if(quant == null || quant <= 0){
            quant = 1;
        }

        this.quantityInput.value = quant + "";
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }))
    }


    defaultProps(): Partial<QuantityInputProps> {
        return {
            submitOnChange: false
        }
    }
}